import type { ImageAsset, Testimonial } from '../types/content';

/** Pages intérieures réelles du guide principal (format portrait 3:4). Vide = bloc masqué. */
export const guideInteriorPages: ImageAsset[] = [];

/** Sélection de vrais modèles issus de la bibliothèque 100+ (format portrait 3:4). Vide = bloc masqué. */
export const templateSamples: ImageAsset[] = [];

/**
 * Témoignages fournis comme réels par la propriétaire (textes inchangés).
 * Les images sont des illustrations générées, pas les créations des clientes.
 */
export const testimonials: Testimonial[] = [{
  id: 't1',
  quote: 'C’était la première fois que je travaillais sur du verre, et les guides pas à pas m’ont vraiment facilité les choses, même à plus de 50 ans ! 😅'
}, {
  id: 't2',
  quote: 'J’ai réalisé ce cadeau fait maison pour une amie, et j’ai déjà envie d’en créer cent autres pour moi ! 🙌',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/98d04c64-e391-4241-9e28-cbed5f9eff17.jpg',
  imageAlt: 'Petit cadre floral en faux vitrail posé sur une commode, à côté d’un nœud en lin et d’une carte cadeau',
  imageIsIllustration: true
}, {
  id: 't5',
  quote: 'Un très bon achat pour celles et ceux qui veulent commencer à créer de leurs propres mains. Mon tout premier loisir créatif 🤞🏻'
}, {
  id: 't6',
  quote: 'J’ai réalisé ce miroir toute seule !! Il est tellement beau qu’on dirait que je l’ai acheté en boutique !!!!',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/90dfe542-7b9d-4887-a1ee-dc406f47bfed.jpg',
  imageAlt: 'Miroir rond à la bordure peinte en faux vitrail, accroché dans un salon chaleureux',
  imageIsIllustration: true
}];
